import * as React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import { useSnackbar } from '../state/SnackbarContext';

export default function PositionedSnackbar() {
    const { isOpen, text, element, error } = useSnackbar();
    const key = Date.now();

    const messageText = error ? (element ? text + " - brak danych" : text + " - kliknij poziom niżej") : text;
    return (
        <Box>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={isOpen}
                message={messageText}
                key={key}
                ContentProps={{
                    style: {
                        backgroundColor: "#2c5a82",
                        textTransform: "uppercase",
                        fontSize: "17px",
                        fontFamily: "Open Sans, sans-serif",
                        fontWeight: "400"
                    }
                }
                }
            />
        </Box>
    );
}